import { useTranslationInterface } from 'utils/hooks/useTranslation';

export const useCampaignsTranslation = () => useTranslationInterface('campaigns');
